import { traverseNodeSubtree, type DesignerNodeData } from "@skilitics/nautilus-core-designer-data";

import { getContentRef, type SlotRef } from "./getContentNode.ts";

export interface CollectBoundSlotRefsOptions {
  // Skip this subtree — e.g. the resident a paste-and-replace displaces.
  excludeSubtreeOfId?: number;
}

// Slot refs bind to the nearest containing layoutable, so every ref collected here binds outward.
export const collectBoundSlotRefs = (
  subtreeRoot: DesignerNodeData,
  { excludeSubtreeOfId }: CollectBoundSlotRefsOptions = {},
): SlotRef[] => {
  const slotRefs: SlotRef[] = [];

  traverseNodeSubtree(subtreeRoot, (node, ancestors) => {
    if (
      excludeSubtreeOfId !== undefined &&
      (node.id === excludeSubtreeOfId || ancestors.some(({ id }) => id === excludeSubtreeOfId))
    ) {
      return;
    }
    const contentRef = getContentRef(node);
    if (typeof contentRef === "object") {
      slotRefs.push(contentRef);
    }
  });

  return slotRefs;
};

// A subtree may bind the same slot ref from several layout.slots; collapse to one per name+index.
export const distinctSlotRefs = (slotRefs: readonly SlotRef[]): SlotRef[] => {
  const byKey = new Map<string, SlotRef>();
  for (const slotRef of slotRefs) {
    const key = `${slotRef.name}#${slotRef.index ?? ""}`;
    if (!byKey.has(key)) byKey.set(key, slotRef);
  }
  return [...byKey.values()];
};
